import { useEffect, type ReactNode } from 'react';
import { useAuth } from 'react-oidc-context';
import { signalRService } from '@/services/signalr';
import { SignalRContext } from '@/context/SignalRContext';

export function SignalRProvider({ children }: { children: ReactNode }) {
  const auth = useAuth();

  useEffect(() => {
    if (!auth.isAuthenticated) return;
    void signalRService.start();
    return () => {
      void signalRService.stop();
    };
  }, [auth.isAuthenticated]);

  return <SignalRContext.Provider value={signalRService}>{children}</SignalRContext.Provider>;
}
